import React, {useState} from 'react';
import styled from 'styled-components';

import ArrowDownIcon from '../../../../Icons/ArrowDownIcon';
import TickIcon from '../../../../Icons/TickIcon';

const SpecialRequestBlock = ({updateSpecialRequest, open, setOpen}) => {
  return (
    <SpecialRequestOuterWrapDiv>
      <SpecialRequestInnerWrapDiv>
        <SpecialRequestMainWrapDiv>
          
          <VerifiedUserDiv>
            {/* <TickDiv></TickDiv> */}
            <PricingTxtSpan>SPECIAL REQUEST</PricingTxtSpan>
          </VerifiedUserDiv>

          <CircularDiv onClick={() => setOpen(state => !state)}>
            <ArrowDownNewWrap transformstyle={(open && 'rotate(180deg)') || 'rotate(0deg)'} />
          </CircularDiv>

        </SpecialRequestMainWrapDiv>
        
        {open && (
          <RequestWrapDiv>
            <FirstTextWrapDiv>Add any special request for your stay at the Hotel and fulfilment is subject to hotels discretion and may be chargeable</FirstTextWrapDiv>

            {/* <SecondTextWrapDiv>
              (Add any special request for your stay at the Hotel and fulfilment is subject to
              hotels discreation and may be chargeable)
            </SecondTextWrapDiv> */}
            <SecondTextWrapDiv>
              (Disclaimer: Customer needs to connect with the Hotel directly to get update on the status of special request)
            </SecondTextWrapDiv>

            <OuterWrapperEntryDiv>
              <SpecialRequestEnterInput
                type="text"
                placeholder="Enter Special Request"
                onBlur={e => updateSpecialRequest('specialReq', e.target.value)}
              />
            </OuterWrapperEntryDiv>


          </RequestWrapDiv>
        )}

      </SpecialRequestInnerWrapDiv>
    </SpecialRequestOuterWrapDiv>
  );
};

export default SpecialRequestBlock;

const SpecialRequestOuterWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:100%;
  margin-top:${props.theme.spacing.large.l12};
`,
);

const SpecialRequestInnerWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:100%;
  background-color: ${props.theme.colors.white.base};
  border-radius: 1rem;
  box-shadow: 0 4px 8px 0 rgba(138, 107, 118, 0.08);
`,
);

const RequestWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    width:100%;
    border-top: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lightdd};
`,
);

const SpecialRequestMainWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l20};
  justify-content:space-between;
  align-items: center;
`,
);

const PricingTxtSpan = styled.span(
  props => `
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.black};
    font-size:${props.theme.font.large.font18};
`,
);

const FirstTextWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  padding-right:${props.theme.spacing.large.l20};
  padding-left:${props.theme.spacing.large.l20};
  padding-bottom:${props.theme.spacing.small.s5};
  padding-top:${props.theme.spacing.large.l15};
  font-weight: bold;
  font-size:${props.theme.font.large.font14};
  color:${props.theme.colors.black.base};


`,
);

const SecondTextWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  padding-right:${props.theme.spacing.large.l20};
  padding-left:${props.theme.spacing.large.l20};
  padding-top:${props.theme.spacing.base};
  font-size:${props.theme.font.base};
  color:${props.theme.colors.red.base};


`,
);

const SpecialRequestEnterInput = styled.input(
  props => `
    display: inline-flex;
    width:64.3rem;
    border: none;
    padding:${props.theme.spacing.base};
    font-size: ${props.theme.font.large.font14};
    border:${props.theme.misc.border.base} solid ${props.theme.colors.grey.lightd7};

    margin-bottom:${props.theme.spacing.base};
    color: ${props.theme.colors.black.base};
    border-radius:${props.theme.misc.borderRadius.base};
    height:11.6rem;

    ::placeholder {
      color: ${props.theme.colors.grey.grey50};
      opacity: 1; /* Firefox */
      font-size: ${props.theme.font.large.font14};


    }
    :-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: ${props.theme.colors.grey.grey50};
      font-size: ${props.theme.font.large.font14};

    }
    ::-ms-input-placeholder { /* Microsoft Edge */
      color: ${props.theme.colors.grey.grey50};
      font-size: ${props.theme.font.large.font14};

    }

    &:focus{
      box-shadow: none;
      outline-offset: 0;
      outline: 0;
    }

  `,
);

const OuterWrapperEntryDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  padding-right:${props.theme.spacing.large.l20};
  padding-left:${props.theme.spacing.large.l20};
  padding-bottom:${props.theme.spacing.large.l25};
  padding-top:${props.theme.spacing.large.l15};

`,
);

const CircularDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  width:2.6rem;
  height:2.6rem;
`,
);

const ArrowDownNewWrap = styled(ArrowDownIcon)(
  props => `
      width:1rem;
      height:1rem;
      fill: ${props.theme.colors.blue.base};
      margin-top:${props.theme.spacing.small.s8};
      margin-left:${props.theme.spacing.small.s8};
      position:absolute;
      transform: ${props.transformstyle};
      transition: transform 0.5s;
  `,
);

const VerifiedUserDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items:center;

`,
);
